import { useFormContext } from 'react-hook-form';
import { InfoCollectionFormType } from '../types';

export const useInfoCollectionFormCtx = () => {
  const {
    control,
    formState,
    getValues,
    handleSubmit,
    reset,
    resetField,
    setError,
    setValue,
    trigger,
    watch,
  } = useFormContext<InfoCollectionFormType>();

  const { errors, isDirty, isValid, touchedFields } = formState;

  return {
    control,
    errors,
    formState,
    isDirty,
    isValid,
    touchedFields,
    getValues,
    handleSubmit,
    reset,
    resetField,
    setError,
    setValue,
    trigger,
    watch,
  };
};
